// extracted by mini-css-extract-plugin
export var legendIndicator = "_hm-1";
export var legendRight = "_hm-0";